import React, { useState } from "react";
import { useForm } from "react-final-form";
import {
  required,
  Button,
  SaveButton,
  TextInput,
  useCreate,
  useNotify,
  FormWithRedirect
} from "react-admin";
import Alert from "@material-ui/lab/Alert";
import IconContentAdd from "@material-ui/icons/Add";
import IconCancel from "@material-ui/icons/Cancel";
import { compareTwoStrings } from "string-similarity";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

function PersonQuickCreateButton({ onChange, players }) {
  const [showDialog, setShowDialog] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [warning, setWarning] = useState("");
  const [create, { loading }] = useCreate("people");
  const notify = useNotify();
  const form = useForm();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
    setShowVerify(false);
    setWarning("");
  };

  const handleSubmit = async (values) => {
    console.log("PersonQuickCreateButton.handleSubmit()", values);
    const fullName = `${values.firstName} ${values.lastName}`;
    const filtered = players.filter((val) => {
      // Comparing against .6 based on personal preference and various testing of misspellings / intentionally trying to trigger duplicates
      return compareTwoStrings(val.toLowerCase(), fullName.toLowerCase()) > 0.6;
    });
    if (showVerify) {
      setShowVerify(false);
      setWarning("");
      create(
        {
          payload: { data: values }
        },
        {
          onSuccess: ({ data }) => {
            console.log(
              "PersonQuickCreateButton.handleSubmit.success():",
              data
            );
            setShowDialog(false);
            form.change("person.id", data.id);
            onChange();
          },
          onFailure: ({ error }) => {
            console.log(
              "PersonQuickCreateButton.handleSubmit.failure():",
              error
            );
            notify(error.message, "error");
          }
        }
      );
    } else if (filtered.length > 0) {
      setShowVerify(true);
      notify(`Similar player found on SeasonTeam: ${filtered.toString()}`);
      setWarning(
        `Similarly named player found on SeasonTeam: ${filtered.toString()}`
      );
    } else {
      setShowVerify(false);
      setWarning("");
      create(
        {
          payload: { data: values }
        },
        {
          onSuccess: ({ data }) => {
            console.log(
              "PersonQuickCreateButton.handleSubmit.success():",
              data
            );
            setShowDialog(false);
            form.change("person.id", data.id);
            onChange();
          },
          onFailure: ({ error }) => {
            console.log(
              "PersonQuickCreateButton.handleSubmit.failure():",
              error
            );
            notify(error.message, "error");
          }
        }
      );
    }
  };

  return (
    <>
      <Button onClick={handleClick} label="ra.action.create">
        <IconContentAdd />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create Person"
      >
        <DialogTitle>Create Person</DialogTitle>

        <FormWithRedirect
          resource="people"
          save={handleSubmit}
          toolbar={null}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <TextInput source="firstName" validate={required()} fullWidth />
                <TextInput source="lastName" validate={required()} fullWidth />
                <TextInput source="middleInitial" fullWidth />
                {warning.length > 0 ? (
                  <Alert severity="warning">{warning}</Alert>
                ) : null}
              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={handleCloseClick}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                {showVerify ? (
                  <SaveButton
                    label={"Proceed with Save"}
                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                    pristine={pristine}
                    saving={saving}
                    disabled={loading}
                  />
                ) : (
                  <SaveButton
                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                    pristine={pristine}
                    saving={saving}
                    disabled={loading}
                  />
                )}
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
}

export default PersonQuickCreateButton;
